import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.VUE_APP_API,
    withCredentials: true,
    timeout: 5000, // set the default timeout for requests to 5 seconds
});

instance.interceptors.request.use(function (config) {
    // let currency = localStorage.getItem('currency');
    // if (!currency) {
    //     // Если валюта не установлена, попробуем получить первую доступную из API
    //     // или используем USD как fallback
    //     currency = 'USD'
    // }
    
    // Добавляем валюту только если она еще не установлена в данных/параметрах
    if (config.method === 'get') {
        if (!config.params || !config.params.currency) {
            config.params = {
                ...config.params,
                // currency
            }
        }
    } else if(['post', 'put', 'patch', 'POST', 'PUT', 'PATCH'].includes(config.method)) {
        if (!config.data || !config.data.currency) {
            config.data = {
                ...config.data,
                // currency
            }
        }
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

export default instance;